import { IdentityVerificationStatus } from '../types/ProcessPlaidIdentityVerification';

export interface StatusMessage {
  title: string;
  message: string;
}

export const identityVerificationStatusMessages: Record<IdentityVerificationStatus, StatusMessage> = {
  [IdentityVerificationStatus.Active]: {
    title: "Unable to verify your identity using Plaid",
    message: "No worries! We have received your request and are reviewing your information. Please proceed with the application process, and we will complete the verification of your identity after your application has been submitted!"
  },
  [IdentityVerificationStatus.Success]: {
    title: "Identity verified successfully",
    message: "Please continue with your application!"
  },
  [IdentityVerificationStatus.Failed]: {
    title: "Unable to verify your identity using Plaid",
    message: "No worries! We have received your request and are reviewing your information. Please proceed with the application process, and we will complete the verification of your identity after your application has been submitted!"
  },
  [IdentityVerificationStatus.Expired]: {
    title: "Unable to verify your identity using Plaid",
    message: "No worries! We have received your request and are reviewing your information. Please proceed with the application process, and we will complete the verification of your identity after your application has been submitted!"
  },
  [IdentityVerificationStatus.Canceled]: {
    title: "Unable to verify your identity using Plaid",
    message: "No worries! We have received your request and are reviewing your information. Please proceed with the application process, and we will complete the verification of your identity after your application has been submitted!"
  },
  [IdentityVerificationStatus.PendingReview]: {
    title: "Unable to verify your identity using Plaid",
    message: "No worries! We have received your request and are reviewing your information. Please proceed with the application process, and we will complete the verification of your identity after your application has been submitted!"
  },
  [IdentityVerificationStatus.Undefined]: {
    title: "Unable to verify your identity using Plaid",
    message: "No worries! We have received your request and are reviewing your information. Please proceed with the application process, and we will complete the verification of your identity after your application has been submitted!"
  }
};

export const getStatusMessage = (status: IdentityVerificationStatus): StatusMessage => {
  return identityVerificationStatusMessages[status] || identityVerificationStatusMessages[IdentityVerificationStatus.Undefined];
};
